<template>

  <div class="commands-list">
    <v-checkbox v-for="(command, index) in options"
                :key="index"
                :disabled="readonly"
                :label="command.label"
                :value="command.method"
                :input-value="value"
                @change="$emit('input', $event)"
    />

    <no-data v-if="!options.length" medium>{{ $t('assets.no-commands') }}</no-data>
  </div>

</template>

<script>
  import NoData from '../../../shared/no-data'
  export default {
    name: 'commands-list',

    props: [ 'options', 'value', 'readonly' ],

    components: {
      NoData
    }
  }
</script>

<style scoped lang="scss">

  .commands-list {
    height: 100%;
  }

  ::v-deep {
    .v-input {
      &:not(:first-child) {
        margin-top: 0;
      }

      .v-messages {
        display: none;
      }
    }
  }

</style>
